import React from "react";

export default function CustomToggle({text, onClick, selected})
{
    return(
        <button
            className={!selected ? "category-button" : "category-button-selected"}
            onClick={onClick}
        >
            {text}
        </button>)
}
